<template>
  <div class="root">
    <section>
      <div class="container">
        <div class="row">
          <div class="col-12 push-down-20">
            <h3>Hang Tight!</h3>
            <p>We will get this content created soon</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name:'NotImplemented'
}
</script>

<style>

</style>